<template>
  <v-container fluid grid-list-lg>
    <v-row>
      <v-col>
        <span
          class="headline font-weight-regular"
          v-bind:class="moveTitleClassObject"
        >
          Dashboard
          <v-icon>mdi-chevron-double-right</v-icon>
          {{ title }}
        </span></v-col
      >
      <v-col md="auto">
        <v-btn text dark mediun color="secondary" @click="loadData">
          <v-icon dark>mdi-refresh</v-icon>
          Actualizar
        </v-btn>
        <excell
          :items="dataTableItems"
          :headers="xlsxHeaders"
          :fieldValues="xlsxFields"
        ></excell>
      </v-col>
    </v-row>

    <resume
      :isLoading="loading"
      :presupuestoPlanificado="presupuestoPlanificado"
      :itemsPlanificados="itemsPlanificados"
      :presupuestoEjecutado="presupuestoEjecutado"
      :itemsEjecutados="itemsEjecutados"
    ></resume>

    <v-row class="px-3">
      <v-tabs v-model="tab">
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1" v-bind:class="moveTitleFiltersClassObject">
          <span>{{ this.$Amplify.I18n.get("Gráfico") }}</span>
          <v-badge
            rigth
            class="pr-5"
            transition="scale-transition"
            origin="center center"
          >
            <template v-slot:badge v-if="dataTableItems.length > 0">
              <span>{{ dataTableItems.length }}</span>
            </template>
          </v-badge>
        </v-tab>
        <v-tab href="#tab-2" v-bind:class="moveTitleQueriesClassObject">
          <span>{{ this.$Amplify.I18n.get("Datos") }}</span>
          <v-badge
            rigth
            class="pr-5"
            transition="scale-transition"
            origin="center center"
          >
            <template v-slot:badge v-if="dataTableItems.length > 0">
              <span>{{ dataTableItems.length }}</span>
            </template>
          </v-badge>
        </v-tab>

        <v-tab-item value="tab-1">
          <horizontal-bar-chart
            v-bind:style="{ height: chartHeight + 40 + 'px' }"
            :datos="dataTableItems"
            :yAxisLabelTruncateLength="yAxisLabelTruncateLength"
            :yAxisLabelTruncateSeparator="yAxisLabelTruncateSeparator"
            :filterValue="filterValue"
          ></horizontal-bar-chart>
        </v-tab-item>

        <v-tab-item value="tab-2" class="my-4">
          <v-data-table
            :calculate-widths="true"
            dense
            :items="dataTableItems"
            :headers="headers"
            class="elevation-0"
            style="font-size:10px"
            :loading="loading"
            loading-text="Cargando... Por favor espere"
            :mobile-breakpoint="100"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 100]
            }"
            :top-props="{
              'items-per-page-options': [10, 25, 50, 100]
            }"
          >
            <template v-slot:top="{ items }">
              <v-data-footer></v-data-footer>
            </template>
            <template v-slot:item.presupuesto_2019="{ item }">
              {{ item.presupuesto_2019 | currency }}
            </template>
            <template v-slot:item.ejecutado_2019="{ item }">
              {{ item.ejecutado_2019 | currency }}
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { postDashboard } from "@/api/private/dashboard";
import Excell from "@/components/Excell";
import unzipHeadersAndRows from "@/services/elastic/response/jsonUtils";
import HorizontalBarChart from "@/components/charts/HorizontalBarChart.js";
import Resume from "@/components/Resume";
import merge from "lodash/merge";
import keyBy from "lodash/keyBy";
import values from "lodash/values";
export default {
  name: "Aggregations",
  props: {
    title: String,
    filterValue: String,
    yAxisLabelTruncateLength: {
      type: Number,
      default: 0
    },
    yAxisLabelTruncateSeparator: {
      type: String,
      default: " [...]"
    }
  },
  components: {
    Excell,
    HorizontalBarChart,
    Resume
  },
  data() {
    return {
      tab: null,
      cursor: null,
      dataTableItems: [],
      dataTableItemsEjecutado: [],
      resumePlanificado: [],
      resumeEjecutado: [],
      toggle_exclusive: undefined,
      loading: false,
      dialog: false,
      xlsxHeaders: ["DESCRIPCIÓN", "PRESUPUESTADO", "EJECUTADO"],
      xlsxFields: ["label", "presupuesto_2019", "ejecutado_2019"],
      headers: [
        { text: "DESCRIPCIÓN", value: "label" },
        { text: "PRESUPUESTADO", value: "presupuesto_2019", align: "right" },
        { text: "EJECUTADO", value: "ejecutado_2019", align: "right" }
      ],
      logger: {}
    };
  },
  computed: {
    ...mapGetters([
      "filters"
      // ...
    ]),
    drawer() {
      return !this.$store.getters.dashboardDrawer;
    },
    moveTitleClassObject: function() {
      return {
        "ml-12": !this.$store.getters.dashboardDrawer
      };
    },
    moveTitleFiltersClassObject: function() {
      return {
        "pr-7": this.dataTableItems.length > 0
      };
    },
    moveTitleQueriesClassObject: function() {
      return {
        "pr-7": this.dataTableItems.length > 0
      };
    },
    chartHeight: function() {
      return this.dataTableItems.length * 45 + 60;
    },
    presupuestoPlanificado: function() {
      return this.resumePlanificado.length > 0
        ? this.resumePlanificado[0].presupuesto_2019
        : 0;
    },
    itemsPlanificados: function() {
      return this.resumePlanificado.length > 0
        ? this.resumePlanificado[0].items_2019
        : 0;
    },
    presupuestoEjecutado: function() {
      return this.resumeEjecutado.length > 0
        ? this.resumeEjecutado[0].ejecutado_2019
        : 0;
    },
    itemsEjecutados: function() {
      return this.resumeEjecutado.length > 0
        ? this.resumeEjecutado[0].items_2019
        : 0;
    }
  },
  watch: {
    filters: {
      deep: true,
      handler: function() {
        this.loadData();
      }
    }
  },
  methods: {
    mergeByKey: function(arr1, arr2) {
      let start = 0;
      let merge = [];

      while (start < arr1.length) {
        if (
          arr1[start][`"${this.filterValue}"`] ===
          arr2[start][`"${this.filterValue}"`]
        ) {
          //pushing the merged objects into array
          merge.push({ ...arr1[start], ...arr2[start] });
        }
        //incrementing start value
        start = start + 1;
      }
      return merge;
    },
    loadData: async function() {
      console.log("Loading data..");
      this.dataTableItems = [];
      this.loading = true;
      try {
        let {
          dataTableItems,
          dataTableItemsEjecutado,
          resumePlanificado,
          resumeEjecutado
        } = await postDashboard();
        //({ cursor } = dataTableItems);

        this.dataTableItems = dataTableItems
          ? unzipHeadersAndRows(dataTableItems)
          : [];
        this.dataTableItemsEjecutado = dataTableItems
          ? unzipHeadersAndRows(dataTableItemsEjecutado)
          : [];
        this.resumePlanificado = unzipHeadersAndRows(resumePlanificado);
        this.resumeEjecutado = unzipHeadersAndRows(resumeEjecutado);

        this.dataTableItems = values(
          merge(
            keyBy(this.dataTableItems, "label"),
            keyBy(this.dataTableItemsEjecutado, "label")
          )
        );
        //console.log(items);
        console.log(this.dataTableItems);

        /* this.dataTableItems = this.mergeByKey(
          this.dataTableItems,
          this.dataTableItemsEjecutado
        ); */
      } catch (e) {
        console.log(e);
        //this.setError(e);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.loadData();
    this.logger = new this.$Amplify.Logger(this.$options.name);
  }
};
</script>
